<div class="searchbox-summary" (click)="togglesOpenDialog()">
    <div class="searchbox-summary__destination">
        <p class="searchbox-summary__destination__title">{{ searchboxData?.initialData.origin.label }}</p>
    </div>
    <div class="searchbox-summary__details">
        <div class="searchbox-summary__details__content">
            <mb-icon-text>
                <mb-icon icon="calendar"></mb-icon>
                <span>{{ formatDate(searchboxData?.initialData.checkin) }} - {{ formatDate(searchboxData?.initialData.checkout) }}</span>
            </mb-icon-text>
            <div class="searchbox-summary__details__content--separator"></div>
            <mb-icon-text>
                <mb-icon icon="login"></mb-icon>
                <span>{{ searchboxData?.initialData.guests.total }}</span>
            </mb-icon-text>
            <div class="searchbox-summary__details__content--separator"></div>
            <mb-icon-text>
                <mb-icon icon="sleep"></mb-icon>
                <span>{{ searchboxData?.initialData.guests.selectedRooms }}</span>
            </mb-icon-text>
        </div>
        <div class="searchbox-summary__details__look-for">
            <mb-icon icon="search"></mb-icon>
        </div>
    </div>
</div>
